import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\TelemetryController::index
* @see app/Http/Controllers/Admin/TelemetryController.php:33
* @route '/admin/telemetry'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::index
* @see app/Http/Controllers/Admin/TelemetryController.php:33
* @route '/admin/telemetry'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::index
* @see app/Http/Controllers/Admin/TelemetryController.php:33
* @route '/admin/telemetry'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::index
* @see app/Http/Controllers/Admin/TelemetryController.php:33
* @route '/admin/telemetry'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::overview
* @see app/Http/Controllers/Admin/TelemetryController.php:666
* @route '/admin/telemetry/overview'
*/
export const overview = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: overview.url(options),
    method: 'get',
})

overview.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry/overview',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::overview
* @see app/Http/Controllers/Admin/TelemetryController.php:666
* @route '/admin/telemetry/overview'
*/
overview.url = (options?: RouteQueryOptions) => {
    return overview.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::overview
* @see app/Http/Controllers/Admin/TelemetryController.php:666
* @route '/admin/telemetry/overview'
*/
overview.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: overview.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::overview
* @see app/Http/Controllers/Admin/TelemetryController.php:666
* @route '/admin/telemetry/overview'
*/
overview.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: overview.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::currentStatus
* @see app/Http/Controllers/Admin/TelemetryController.php:835
* @route '/admin/telemetry/current-status'
*/
export const currentStatus = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: currentStatus.url(options),
    method: 'get',
})

currentStatus.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry/current-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::currentStatus
* @see app/Http/Controllers/Admin/TelemetryController.php:835
* @route '/admin/telemetry/current-status'
*/
currentStatus.url = (options?: RouteQueryOptions) => {
    return currentStatus.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::currentStatus
* @see app/Http/Controllers/Admin/TelemetryController.php:835
* @route '/admin/telemetry/current-status'
*/
currentStatus.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: currentStatus.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::currentStatus
* @see app/Http/Controllers/Admin/TelemetryController.php:835
* @route '/admin/telemetry/current-status'
*/
currentStatus.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: currentStatus.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::day
* @see app/Http/Controllers/Admin/TelemetryController.php:878
* @route '/admin/telemetry/day/{telemetryData}'
*/
export const day = (args: { telemetryData: number | { id: number } } | [telemetryData: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: day.url(args, options),
    method: 'get',
})

day.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry/day/{telemetryData}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::day
* @see app/Http/Controllers/Admin/TelemetryController.php:878
* @route '/admin/telemetry/day/{telemetryData}'
*/
day.url = (args: { telemetryData: number | { id: number } } | [telemetryData: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { telemetryData: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { telemetryData: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            telemetryData: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        telemetryData: typeof args.telemetryData === 'object'
        ? args.telemetryData.id
        : args.telemetryData,
    }

    return day.definition.url
            .replace('{telemetryData}', parsedArgs.telemetryData.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::day
* @see app/Http/Controllers/Admin/TelemetryController.php:878
* @route '/admin/telemetry/day/{telemetryData}'
*/
day.get = (args: { telemetryData: number | { id: number } } | [telemetryData: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: day.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::day
* @see app/Http/Controllers/Admin/TelemetryController.php:878
* @route '/admin/telemetry/day/{telemetryData}'
*/
day.head = (args: { telemetryData: number | { id: number } } | [telemetryData: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: day.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::assign
* @see app/Http/Controllers/Admin/TelemetryController.php:462
* @route '/admin/telemetry/assign'
*/
export const assign = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(options),
    method: 'post',
})

assign.definition = {
    methods: ["post"],
    url: '/admin/telemetry/assign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::assign
* @see app/Http/Controllers/Admin/TelemetryController.php:462
* @route '/admin/telemetry/assign'
*/
assign.url = (options?: RouteQueryOptions) => {
    return assign.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::assign
* @see app/Http/Controllers/Admin/TelemetryController.php:462
* @route '/admin/telemetry/assign'
*/
assign.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::autoAssign
* @see app/Http/Controllers/Admin/TelemetryController.php:415
* @route '/admin/telemetry/auto-assign'
*/
export const autoAssign = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoAssign.url(options),
    method: 'post',
})

autoAssign.definition = {
    methods: ["post"],
    url: '/admin/telemetry/auto-assign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::autoAssign
* @see app/Http/Controllers/Admin/TelemetryController.php:415
* @route '/admin/telemetry/auto-assign'
*/
autoAssign.url = (options?: RouteQueryOptions) => {
    return autoAssign.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::autoAssign
* @see app/Http/Controllers/Admin/TelemetryController.php:415
* @route '/admin/telemetry/auto-assign'
*/
autoAssign.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoAssign.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::unassign
* @see app/Http/Controllers/Admin/TelemetryController.php:499
* @route '/admin/telemetry/unassign'
*/
export const unassign = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unassign.url(options),
    method: 'post',
})

unassign.definition = {
    methods: ["post"],
    url: '/admin/telemetry/unassign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::unassign
* @see app/Http/Controllers/Admin/TelemetryController.php:499
* @route '/admin/telemetry/unassign'
*/
unassign.url = (options?: RouteQueryOptions) => {
    return unassign.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::unassign
* @see app/Http/Controllers/Admin/TelemetryController.php:499
* @route '/admin/telemetry/unassign'
*/
unassign.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unassign.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::sync
* @see app/Http/Controllers/Admin/TelemetryController.php:539
* @route '/admin/telemetry/{reservation}/sync'
*/
export const sync = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sync.url(args, options),
    method: 'post',
})

sync.definition = {
    methods: ["post"],
    url: '/admin/telemetry/{reservation}/sync',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::sync
* @see app/Http/Controllers/Admin/TelemetryController.php:539
* @route '/admin/telemetry/{reservation}/sync'
*/
sync.url = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reservation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { reservation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            reservation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reservation: typeof args.reservation === 'object'
        ? args.reservation.id
        : args.reservation,
    }

    return sync.definition.url
            .replace('{reservation}', parsedArgs.reservation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::sync
* @see app/Http/Controllers/Admin/TelemetryController.php:539
* @route '/admin/telemetry/{reservation}/sync'
*/
sync.post = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sync.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::show
* @see app/Http/Controllers/Admin/TelemetryController.php:154
* @route '/admin/telemetry/{reservation}'
*/
export const show = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/telemetry/{reservation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TelemetryController::show
* @see app/Http/Controllers/Admin/TelemetryController.php:154
* @route '/admin/telemetry/{reservation}'
*/
show.url = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reservation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { reservation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            reservation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reservation: typeof args.reservation === 'object'
        ? args.reservation.id
        : args.reservation,
    }

    return show.definition.url
            .replace('{reservation}', parsedArgs.reservation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TelemetryController::show
* @see app/Http/Controllers/Admin/TelemetryController.php:154
* @route '/admin/telemetry/{reservation}'
*/
show.get = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TelemetryController::show
* @see app/Http/Controllers/Admin/TelemetryController.php:154
* @route '/admin/telemetry/{reservation}'
*/
show.head = (args: { reservation: number | { id: number } } | [reservation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const telemetry = {
    index: Object.assign(index, index),
    overview: Object.assign(overview, overview),
    currentStatus: Object.assign(currentStatus, currentStatus),
    day: Object.assign(day, day),
    assign: Object.assign(assign, assign),
    autoAssign: Object.assign(autoAssign, autoAssign),
    unassign: Object.assign(unassign, unassign),
    sync: Object.assign(sync, sync),
    show: Object.assign(show, show),
}

export default telemetry